export default __webpack_public_path__ + "static/media/move.013e83cf.svg";